var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarrot1 = function SvgCarrot1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 160,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    d: "M26.835 58.144c2.15 4.543 6.915 5.362 9.376 4.248 3.901-1.819 4.008-4.143 6.644-4.569 3.17-.553 5.01 4.083 9.232 6.786 4.223 2.703 12.372 3.006 12.372 3.006L52.531 51.799s-8.866-11.482-20.259-6.119c-5.019 2.359-7.949 7.054-5.437 12.464Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    d: "M32.88 54.499s13.493-5.222 28.275 11.889"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    d: "M81.103 32.545c2.15 4.544-.257 8.743-2.73 9.929-3.902 1.818-5.723.48-7.772 2.178-2.407 2.076-.008 6.442-.65 11.458-.559 4.956-5.55 11.42-5.55 11.42l-4.545-19.16s-3.217-14.1 8.177-19.463c5.032-2.43 10.487-1.785 13.07 3.638Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    d: "M74.483 34.848s-12.638 7.054-8.785 29.391"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    d: "M58.532 26.25c-3.052-6.53-11.18-9.098-17.558-5.216-4.845 3.048-6.987 9.123-5.056 14.508a12.35 12.35 0 0 0 5.189 6.457c2.26 1.34 4.029 3.402 4.693 5.932.14.464.28.927.503 1.331 1.069 2.307 3.066 3.896 5.293 4.572 2.157.663 4.036 2.085 5.32 3.99 3.039 4.476 7.486 9.707 7.486 9.707s-1.247-6.804-2.776-11.973c-.654-2.163-.535-4.559.33-6.607.888-2.19.948-4.67-.12-6.976a7.3 7.3 0 0 0-.73-1.297 9.62 9.62 0 0 1-1.625-7.163c.416-2.418.107-4.887-.949-7.265Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    d: "M93.833 129.779c-2.39 1.127-5.305.187-6.587-2.157L59.342 76.914c-2.4-4.367-.593-9.768 3.88-11.927 4.46-2.09 9.812.002 11.664 4.568l21.447 53.771a5.013 5.013 0 0 1-2.5 6.453Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    d: "M45.251 26.822 63.3 64.998M59.416 76.926l5.899-2.793M71.485 78.708l5.97-2.781M68.396 93.701l5.97-2.781M80.215 100.346l5.97-2.782M78.803 111.966l5.97-2.782M88.758 121.366l5.97-2.782"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "carrot1_svg__a",
    width: 122,
    height: 115,
    x: 92,
    y: -25,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M92.339-25h121.243V89.027H92.339z"
  }))));
};
export default SvgCarrot1;